import { combineReducers } from 'redux';

import { UserGroups } from '../auth/constants';
import { Actions, ActionTypes } from '../auth/session/actions';

interface IUserFeatureFlags {
	canViewBookings: boolean;
	canCreateProperty: boolean;
	canEditAvailability: boolean;
	canEditPricing: boolean;
}

const defaultUserFeatureFlags = {
	canViewBookings: false,
	canCreateProperty: false,
	canEditAvailability: false,
	canEditPricing: false
} as IUserFeatureFlags;

export const userFeatures = (state = defaultUserFeatureFlags, action: Actions = {} as any): IUserFeatureFlags => {
	switch (action.type) {
		case ActionTypes.SESSION_CREATE_RECEIVE:
			return {
				...state,
				canViewBookings: action.payload.groups.includes(UserGroups.ADMIN_BOOKING_EDITOR),
				canCreateProperty: action.payload.groups.includes(UserGroups.PROPERTY_CREATOR),
				canEditAvailability: action.payload.groups.includes(UserGroups.AVAILABILITY_EDITOR),
				canEditPricing: action.payload.groups.includes(UserGroups.PRICING_EDITOR)
			};
		case ActionTypes.SESSION_DESTROY:
			return { ...state, ...defaultUserFeatureFlags };
		default:
			return state;
	}
};

export interface IFlagsState {
	userFeatures: ReturnType<typeof userFeatures>;
}

export default combineReducers<IFlagsState>({
	userFeatures
});
